import { PageData } from "hooks/usePagination";
import { TablePagination } from "@mui/material";

export interface PaginationProps {
  pageData: PageData;
  changePage: (pageNumber: number) => void;
  changePageSize: (pageSize: number) => void;
  loading?: boolean;
  rowsPerPageOptions?: number[];
}

function Pagination(props: PaginationProps): JSX.Element {
  const { 
    pageData, 
    changePage, 
    changePageSize, 
    loading,
    rowsPerPageOptions = [10, 20, 30, 40]
  } = props;

  return (
    <TablePagination
      disabled={loading}
      rowsPerPageOptions={rowsPerPageOptions}
      component="div"
      count={pageData.count}
      rowsPerPage={pageData.pageSize}
      page={pageData.page}
      onPageChange={(_event, newPage: number) => changePage(newPage)}
      onRowsPerPageChange={(event: React.ChangeEvent<HTMLInputElement>) => 
        changePageSize(+event.target.value)
      }
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        minHeight: "3.5rem",
        "&:MuiTablePagination-toolbar": {
          fontWeight: 600,
        },
      }}
    />
  );
}

export default Pagination;